export default {
  set_current_course (state, course) {
    state.currentCourse = course
  },
}
